export default {
  nav: { title: '蓍草起卦' },
  banner: {
    title: '大衍之數',
    subtitle: '以五十蓍草，揲之以四，歸奇於扐',
  },
  input: { placeholder: '默想所求之事，心誠則靈（可不填）' },
  cast: {
    casting: '成卦中…已成第 {{n}} 爻',
    done: '六爻已成',
    movingYaoCount: '動爻數',
    changingHex: '變卦',
    noChanging: '無變卦',
    hexCount: '{{n}} 爻',
    noChange: '本卦不變',
  },
  btn: {
    start: '開始起卦',
    reset: '重新起卦',
    casting: '蓍草飛舞，靜心等待…',
    share: '分享',
  },
  hexCard: {
    judgment: '卦辭',
    image: '象辭',
    meaning: '白話解義',
    advice: '綜合指示',
    above: '上',
    below: '下',
    hexNum: '第{{n}}卦',
  },
  lineDiagram: {
    lineNum: '第{{n}}爻',
  },
  sections: {
    aspects: '各方面運勢',
    movingYao: '動爻分析',
    future: '變卦 · 未來走向',
  },
  movingYao: {
    desc: '動爻（老陽/老陰）是此次占卜的關鍵變動之處，代表當前形勢中最活躍、最值得關注的能量。',
    laoYang: '陽盛極將變，提示此處能量活躍，宜把握時機而不可固守僵化。',
    laoYin: '陰能沉極而將生，提示當前的沉靜是孕育新變化的前奏，宜沉穩等待時機。',
    lineRef: '第{{n}}爻',
  },
  changingLabel: '由{{from}}變至{{to}}，動爻引發格局轉變',
  warmth:
    '蓍草起卦為傳統易學文化，卦象僅供參考。當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  footer:
    '蓍草起卦為傳統易學文化，當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  idle: {
    introTitle: '何為大衍筮法',
    introBadge: '新手必讀',
    introResultTitle: '大衍筮法結果說明',
    intro: '蓍草起卦源自《周易·系辭》大衍之數：「大衍之數五十，其用四十有九」。以四十九根蓍草經三次分揲，得一爻；六次三揲，成六十四卦之一。此法為傳統《易經》占卜中最嚴謹的方式，強調心誠則靈，問事須專一。',
    yao0Name: '老陽 ☀',
    yao0Desc: '— 陽爻·動變（9）',
    yao0Detail: '陽盛極將變，變動核心',
    yao1Name: '少陽',
    yao1Desc: '— 陽爻·不變（7）',
    yao1Detail: '剛健穩定，持續進取',
    yao2Name: '老陰 🌑',
    yao2Desc: '- - 陰爻·動變（6）',
    yao2Detail: '陰沉極將變，轉化契機',
    yao3Name: '少陰',
    yao3Desc: '- - 陰爻·不變（8）',
    yao3Detail: '柔順內斂，養蓄待時',
    stepsTitle: '起卦流程',
    step0: '靜心專注，默想所求之事',
    step1: '系統模擬大衍筮法三揲一爻',
    step2: '重複六次，由下至上成六爻',
    step3: '根據陰陽動變，推演本卦與變卦',
    probTitle: '傳統概率分佈',
    probDesc: '蓍草筮法的四種爻值出現概率由《周易》大衍之數決定，非均等分佈，少陽出現最頻繁，體現陰陽消長之道。',
  },
  share: {
    resultLabel: '── 卦象結果 ──',
    questionLabel: '所問之事',
    title: '分享卦象結果',
    hint: '長按圖片即可儲存到相冊',
    generating: '生成卡片中…',
    failed: '生成失敗，請重試',
    retry: '重新生成',
    close: '關閉',
    save: '儲存圖片',
    disclaim: '本結果僅供娛樂參考，不代表任何現實指導意義',
  },
  fortuneLabel: {
    5: '大吉', 4: '吉', 3: '平', 2: '需注意', 1: '宜謹慎',
  },
  lineName: {
    laoYang: '老陽', shaoYang: '少陽', laoYin: '老陰', shaoYin: '少陰',
  },
  aspectLabel: {
    love: '感情', career: '事業', wealth: '財運', health: '健康',
  },
  history: {
    title: '起卦歷史',
    recentCount: '最近 {{n}} 次記錄',
    emptyTitle: '暫無起卦記錄',
    emptyDesc: '完成一次起卦後，記錄將自動保存在此',
    hint: '點擊卡片可展開查看卦辭與指示；「查看完整解讀」可返回完整結果頁',
    restore: '查看完整解讀',
    clearTitle: '清空全部記錄？',
    clearDesc: '此操作不可撤銷，{{n}} 條歷史記錄將被永久刪除',
    cancel: '取消',
    confirmClear: '確認清空',
    noQuestion: '無所問之事',
    movingCount: '{{n}}動爻',
    judgment: '卦辭',
    advice: '綜合指示',
    changingTitle: '變卦 · {{name}}',
    formatToday: '今天 {{time}}',
    formatYesterday: '昨天',
    formatDaysAgo: '{{n}}天前',
  },
};
